export default __webpack_public_path__ + "static/media/nav-inbox.02fc99af.svg";